<template>
  <outro-template v-on:next="next" button-label="Passer à la suite" :status="status" :memo="{ label: 'Le glossaire de la GTA', link: 'files/glossaire-gta.pdf' }">
    <template v-slot:title>
      Consulter les congés et heures de récup
    </template>
    <template v-slot:sub-title>
      Le glossaire de la GTA
    </template>
    <template v-slot:score-title>
      Vous avez obtenu {{ score }} points !
    </template>
    <template v-slot:success-detail-title>
      Félicitations, vous parlez couramment GTA
    </template>
    <template v-slot:normal-detail-title>
      Vous avez de bonnes notions
    </template>
    <template v-slot:normal-detail-content>
      mais vous ne parlez pas encore couramment GTA.
    </template>
    <template v-slot:fail-detail-title>
      Vous êtes peu familier des sigles utilisés en GTA,
    </template>
    <template v-slot:fail-detail-content>
      il va pourtant falloir vous y mettre !
      <br>
      <button @click="navigateTo('sigleQuizz')" class="button retry-button">Réessayer</button>
    </template>
  </outro-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'QuizzOutro',
  mixins: [stepMixin],
  computed: {
    score () {
      return this.$store.state.quizzScore
    },
    status () {
      return this.$store.getters.quizzStatus
    }
  }
}
</script>

<style lang="scss">
</style>
